<div class="title-container">
    <div class="title" fxLayout="row" fxLayoutAlign="center center">
        <div>{{title}}</div>
    </div>
    <div class="rectangle"></div>
</div>
